import Vue from 'vue'
import ViewUI from 'view-design';
import './assets/css/less/index.less'
import './assets/css/scss/index.scss'
import router from './router'
import App from './App.vue'
import store from './store/index.js'
import Storage from './plugins/localForage'
import Plugins from './plugins'
import filter from './plugins/filter'// 自訂過濾器
import api from './api'
import vue_component from './plugins/vue_component'
import { sync } from 'vuex-router-sync'
import i18n from './i18n'
import { i18n as i18nHandler } from 'view-design'
import errorCdoe from './plugins/utils/error-code'
i18nHandler((path, options) => {
  let value = i18n.t(path, options);
  if (value !== null && value !== undefined) return value;

  return '';
})

Vue.use(ViewUI, {
  size: 'small',
});
Vue.use(Plugins)
Vue.use(api)
Vue.use(vue_component)
Vue.use(filter)

// sync(store, router, { moduleName: 'RouteModule' })
Vue.config.productionTip = false
Vue.prototype.$Eventhub = new Vue();
Vue.prototype.$localForage = new Storage()
Vue.prototype.$errorCdoe = errorCdoe
new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

if (module.hot) {
  module.hot.accept(['./locales/en-US.json', './locales/zh-CN.json'], function () {
    i18n.setLocaleMessage('en-US', require('./locales/en-US.json').default)
    i18n.setLocaleMessage('zh-CN', require('./locales/zh-CN.json').default)
  })
}